export const RATE_LIMIT_CONFIG = {
  // Supabase RLS (Row Level Security) rate limiting settings
  RLS: {
    // Maximum requests per minute per IP
    maxRequestsPerMinute: 60,
    // Maximum requests per hour per IP
    maxRequestsPerHour: 1000,
    // Maximum requests per day per IP
    maxRequestsPerDay: 5000,
    // Burst protection (requests in a short time window)
    burstWindowSeconds: 10,
    burstLimit: 20,
  },
  
  // Client-side rate limiting settings
  CLIENT: {
    // Maximum concurrent requests
    maxConcurrentRequests: 5,
    // Request timeout in milliseconds
    requestTimeout: 10000,
    // Retry delay in milliseconds
    retryDelay: 1000,
    // Maximum retries
    maxRetries: 3,
  }
}; 